// Form Validation: lower level functions to validate form data
import { staticConstants as constants } from "../../../constants-ui";
import { REGEX, FI_TYPES, FI_STATES } from "./pi1-form-constants";

const { TOGL } = FI_STATES,
  NO = TOGL[0];

export const trimSpace = (val) => val.trim();

export const str2Num = (val) => Number(val);

export const num2Str = (val) => String(val);

// convert date between formats: Form -> API
// FROM: MM/DD/YYYY => YYYY-MM-DD
export const convertDateApi = (val, sep) => {
  const curSep = "/",
    newSep = sep || "-",
    [month, day, year] = val.split(curSep);
  return [year, month, day].join(newSep);
};

// convert date between formats: API -> Form
// FROM: YYYY-MM-DD => MM/DD/YYYY
export const convertDateForm = (val) => {
  const curSep = "-",
    newSep = "/",
    [year, month, day] = val.split(curSep);
  return [month, day, year].join(newSep);
};

// Special case validation checks

// Determine if recipient and applicant are same
// if recipient == applicant, fname and lname are same
// applicant fname and lname are required if recipient !== 'Self'
export const checkPatRel = (val) => {
  let value = Number(val);
  return value !== 6 ? true : false;
};

// Determine if Mailing Address fields are required
export const checkMailToggle = (val) => {
  return val === NO ? true : false;
};

// expects array of number values, [89465, 3452], [0, 0]
export const checkTotalIncGt = (incomes, comp = 0) => {
  let total = incomes.map(Number).reduce((acc, cur) => acc + cur, 0);
  return isNumGreaterThan(total, comp);
};

export const checkStateAndLoanAmt = (state = "", loanAmt = 0) => {
  let stStr,
    bool = false;
  if (typeof state === "string" && state.length > 0) {
    stStr = state.toLowerCase();
    bool = stStr === "ma" && loanAmt <= 6000;
  }

  return bool;
};

// Simple data validation checks

export const isntChecked = (val, cond = true) => {
  let bool = val === cond;
  return bool;
};

export const isntEmpty = (val) => {
  let bool = val !== undefined && val !== ""; // order is important
  return bool;
};

export const isNum = (val) => {
  let num = Number(val), // inputs keep numeric data as string
    bool = typeof num === "number";
  // (typeof val === 'number'); // true if val is string, false
  return bool;
};

export const isEqualTo = (val, compare) => {
  let bool = val === compare;
  return bool;
};

export const isString = (val) => {
  let bool = typeof val === "string"; // true if val is string, false
  return bool;
};

export const isNumLessThan = (val, compare) => {
  let bool = val < compare;
  return bool;
};

export const isNumGreaterThan = (val, compare) => {
  let bool = val > compare;
  return bool;
};

export const isLenLessThan = (val, len) => {
  let bool = val.length < len;
  return bool;
};

export const isLenEqualTo = (val, len) => {
  let bool = val.length === len;
  return bool;
};

export const isLenGreaterThan = (val, len) => {
  let bool = val.length > len;
  return bool;
};

// expects val in the format: 'MM/DD/YYYY' from FE
export const getAgeFromDateStr = (val) => {
  const today = new Date(),
    sep = "/",
    dateStr = convertDateApi(val, sep),
    bDay = new Date(dateStr),
    mon = today.getMonth() - bDay.getMonth();
  let age = today.getFullYear() - bDay.getFullYear();
  if (mon < 0 || (mon === 0 && today.getDate() < bDay.getDate())) {
    age--;
  }
  return age;
};

export const isntOldEnough = (val, minAge) => {
  const age = getAgeFromDateStr(val),
    bool = age >= minAge;
  return bool;
};

export const isntTooOld = (val, maxAge) => {
  const age = getAgeFromDateStr(val),
    bool = age <= maxAge;
  return bool;
};

export const isValidType = (value, type) => {
  const regex = REGEX[type];
  let bool = regex.test(value);
  return bool;
};

export const isntValidPhoneNum = (value) =>
  isValidType(trimSpace(value), FI_TYPES.PHONE_NUM);

export const isntValidMMDDYYYY = (value) =>
  isValidType(trimSpace(value), FI_TYPES.MMDDYYYY);

export const isntValidDDMMYYYY = (value) =>
  isValidType(trimSpace(value), FI_TYPES.DDMMYYYY);

export const isntValidPassword = (value) =>
  isValidType(trimSpace(value), FI_TYPES.PASSWORD);

export const isntPOBox = (value) =>
  !isValidType(trimSpace(value), FI_TYPES.POBOX);

export const isntValidEmail = (value) =>
  isValidType(trimSpace(value), FI_TYPES.EMAIL);

export const isntValidZip = (value) =>
  isValidType(trimSpace(value), FI_TYPES.ZIP);

export const isntDuplicateEmail = (value) => {
  // TODO need to add API call here to determine whether email provided is a duplicate (unique email required)
  return true;
};

// 9 numbers divided by seperators matching this patterh: ###-##-####
export const isntValidSsn = (value) =>
  isValidType(trimSpace(value), FI_TYPES.SSN);

// a string of 9 numbers '#########'
export const isntValidSsnString = (value) =>
  isValidType(trimSpace(value), FI_TYPES.SSN_STRING);

export const isValidLoanAmount = (value, state, clientProducts) => {
  let minValue = (clientProducts && clientProducts.minGeneralAmount) || 499;
  const maxValue = (clientProducts && clientProducts.maxGeneralAmount) || 50000;

  if (state && state.toLowerCase() === "ma") {
    minValue = constants.MA_min_amount.value;
  }

  const amount = value && parseInt(value.replace(/\$|,/g, ""), 10);

  return amount && minValue <= amount && amount <= maxValue;
};

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');